import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "./Styles/AddBlog.css";

const AddBlog = () => {
    const [formData, setFormData] = useState({
        title: "",
        description: "",
        images: []
    });
    const [imageUrls, setImageUrls] = useState([]);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const navigate = useNavigate();

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData(prevData => ({
            ...prevData,
            [name]: value
        }));
        setError(null); // Clear any previous errors
    };

    const handleImageChange = async (e) => {
        const files = Array.from(e.target.files);
        setLoading(true);
        setError(null);

        try {
            // Convert files to base64
            const imagePromises = files.map(file => {
                return new Promise((resolve, reject) => {
                    const reader = new FileReader();
                    reader.onload = () => resolve(reader.result);
                    reader.onerror = reject;
                    reader.readAsDataURL(file);
                });
            });

            const base64Images = await Promise.all(imagePromises);

            setImageUrls(prev => [...prev, ...base64Images]);
            setFormData(prev => ({
                ...prev,
                images: [...prev.images, ...base64Images]
            }));
        } catch (error) {
            console.error("Error processing images:", error);
            setError("Error processing images. Please try again.");
        } finally {
            setLoading(false);
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError(null);

        try {
            const cookies = document.cookie.split("; ");
            const userEmailCookie = cookies.find(row => row.startsWith("userEmail="));
            const email = userEmailCookie ? userEmailCookie.split("=")[1] : "";

            if (!email) {
                throw new Error("You must be logged in to create a blog post");
            }

            console.log('Submitting blog data:', {
                ...formData,
                author: email
            });

            const response = await fetch("https://dalhousiecombatroboticsteam.onrender.com/create-blog", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    ...formData,
                    author: email
                }),
            });

            const data = await response.json();
            console.log('Server response:', data);

            if (!response.ok) {
                throw new Error(data.message || "Error creating blog post");
            }

            alert("Blog post created successfully!");
            navigate("/blogs");
        } catch (error) {
            console.error("Error creating blog:", error);
            setError(error.message || "An error occurred while creating the blog post");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="add-blog-container">
            <h2>Create New Blog Post</h2>
            {error && <div className="error-message">{error}</div>}
            <form onSubmit={handleSubmit}>
                <div className="form-group">
                    <label>Title:</label>
                    <input
                        type="text"
                        name="title"
                        value={formData.title}
                        onChange={handleChange}
                        required
                        disabled={loading}
                        placeholder="Enter blog title"
                    />
                </div>

                <div className="form-group">
                    <label>Description:</label>
                    <textarea
                        name="description"
                        value={formData.description}
                        onChange={handleChange}
                        required
                        rows="6"
                        disabled={loading}
                        placeholder="Enter blog description"
                    />
                </div>

                <div className="form-group">
                    <label>Images:</label>
                    <input
                        type="file"
                        accept="image/*"
                        multiple
                        onChange={handleImageChange}
                        disabled={loading}
                    />
                    <div className="image-preview">
                        {imageUrls.map((url, index) => (
                            <div key={index} className="preview-container">
                                <img src={url} alt={`Preview ${index + 1}`} />
                                <button
                                    type="button"
                                    className="remove-image"
                                    onClick={() => {
                                        setImageUrls(prev => prev.filter((_, i) => i !== index));
                                        setFormData(prev => ({
                                            ...prev,
                                            images: prev.images.filter((_, i) => i !== index)
                                        }));
                                    }}
                                    disabled={loading}
                                >
                                    ×
                                </button>
                            </div>
                        ))}
                    </div>
                </div>

                <button type="submit" disabled={loading}>
                    {loading ? "Creating..." : "Create Blog Post"}
                </button>
            </form>
        </div>
    );
};

export default AddBlog; 